import React from 'react';
import {
  StatGrid,
  Stat,
  StatTop,
  ChartGrid,
  Card,
  Skeleton,
} from '../ui/primitives';

/** Placeholder assessment columns so DataTable shimmer matches loaded layout. */
export const SCORE_LOADING_TABLE_COLUMNS = [
  { header: '\u00a0', render: () => null, mono: true },
  { header: '\u00a0', render: () => null, mono: true },
  { header: '\u00a0', render: () => null, mono: true },
];

/**
 * KPI + chart skeleton band shown while scores fetch is in progress.
 * Mirrors GradeSummary layout so the page does not jump when data arrives.
 */
export function GradeSummaryShimmer() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        marginBottom: 16,
      }}
      aria-busy="true"
      aria-label="Loading scores summary"
    >
      <StatGrid style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {[0, 1, 2].map((i) => (
          <Stat key={i}>
            <StatTop>
              <Skeleton $w="34px" $h="34px" $r="10px" />
            </StatTop>
            <Skeleton $w="70px" $h="11px" $r="6px" $mb="8px" style={{ marginTop: 10 }} />
            <Skeleton $w="50px" $h="26px" $r="6px" />
          </Stat>
        ))}
      </StatGrid>

      <ChartGrid>
        <Card $pad>
          <Skeleton $w="160px" $h="16px" $mb="16px" />
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                marginBottom: i < 3 ? 14 : 0,
              }}
            >
              <Skeleton $w="64px" $h="13px" />
              <div style={{ flex: 1 }}>
                <Skeleton $w="100%" $h="28px" $r="8px" />
              </div>
              <Skeleton $w="24px" $h="13px" />
            </div>
          ))}
        </Card>

        <Card $pad>
          <Skeleton $w="120px" $h="16px" $mb="8px" />
          <Skeleton $w="180px" $h="11px" $mb="18px" />
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 0',
              }}
            >
              <Skeleton $w="18px" $h="13px" />
              <Skeleton $circle $h="30px" />
              <div style={{ flex: 1, minWidth: 0 }}>
                <Skeleton $w="55%" $h="12px" $mb="6px" />
                <Skeleton $w="38%" $h="10px" />
              </div>
              <Skeleton $w="44px" $h="22px" $r="999px" />
            </div>
          ))}
        </Card>
      </ChartGrid>
    </div>
  );
}
